var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { Chart, Axis, Tooltip, Geom } from 'bizcharts';
import Debounce from 'lodash-decorators/debounce';
import Bind from 'lodash-decorators/bind';
import autoHeight from '../autoHeight';
import '../index.less';
class Bar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            autoHideXLabels: false,
        };
        this.handleRoot = (n) => {
            this.root = n;
        };
        this.handleRef = (n) => {
            this.node = n;
        };
    }
    componentDidMount() {
        window.addEventListener('resize', this.resize, { passive: true });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }
    resize() {
        if (!this.node) {
            return;
        }
        const canvasWidth = this.node.parentNode.clientWidth;
        const { data = [], autoLabel = true } = this.props;
        if (!autoLabel) {
            return;
        }
        const minWidth = data.length * 30;
        const { autoHideXLabels } = this.state;
        if (canvasWidth <= minWidth) {
            if (!autoHideXLabels) {
                this.setState({
                    autoHideXLabels: true,
                });
            }
        }
        else if (autoHideXLabels) {
            this.setState({
                autoHideXLabels: false,
            });
        }
    }
    render() {
        const { height, title, forceFit = true, data, color = 'rgba(24, 144, 255, 0.85)', padding, } = this.props;
        const scale = {
            x: {
                type: 'cat',
            },
            y: {
                min: 0,
            },
        };
        const tooltip = [
            'x*y',
            (x, y) => ({
                name: x,
                value: y,
            }),
        ];
        return (React.createElement("div", { className: "chart", style: { height }, ref: this.handleRoot },
            React.createElement("div", { ref: this.handleRef },
                title && React.createElement("h4", { style: { marginBottom: 20 } }, title),
                React.createElement(Chart, { scale: scale, height: title ? height - 41 : height, forceFit: forceFit, data: data, padding: padding || 'auto' },
                    React.createElement(Axis, { name: "x", title: false }),
                    React.createElement(Axis, { name: "y", min: 0 }),
                    React.createElement(Tooltip, { showTitle: false, crosshairs: false }),
                    React.createElement(Geom, { type: "interval", position: "x*y", color: color, tooltip: tooltip })))));
    }
}
__decorate([
    Bind(),
    Debounce(400)
], Bar.prototype, "resize", null);
export default autoHeight()(Bar);
